module.exports = __webpack_public_path__ + "static/media/18ECA6.5bf43088.jpg";